import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import CatalogPage from './pages/CatalogPage';
import InventoryPage from './pages/InventoryPage';
import TradesPage from './pages/TradesPage';
import SearchPage from './pages/SearchPage';
import ProfilePage from './pages/ProfilePage';
import { AdminRoute } from './components/layout/AdminRoute';
import AdminLayout from './pages/admin/AdminLayout';
import AdminResumenPage from './pages/admin/AdminResumenPage';
import AdminUsuariosPage from './pages/admin/AdminUsuariosPage';
import AdminTradesPage from './pages/admin/AdminTradesPage';
import AdminInventarioPage from './pages/admin/AdminInventarioPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/catalog" replace />} />
        <Route path="catalog" element={<CatalogPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="trades" element={<TradesPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="profile" element={<ProfilePage />} />
        {/* Admin dashboard */}
        <Route
          path="admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<AdminResumenPage />} />
          <Route path="usuarios" element={<AdminUsuariosPage />} />
          <Route path="trades" element={<AdminTradesPage />} />
          <Route path="inventario" element={<AdminInventarioPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
